import DeleteBeacon from "./DeleteBeacon";

export default DeleteBeacon